import styled from "styled-components";

const Price = styled.div`
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 5px 8px;
  font-size: 18px;
`;

export default Price;
